export default {"src":"/_next/static/media/ftIcon4.787d0819.svg","height":66,"width":68};